// extracted by mini-css-extract-plugin
export var icon = "_6y-1";
export var subtext = "_6y-0";